import React, { FC } from "react";
import { WidgetLengthPickerLine } from "./WidgetLengthPickerLine";

export interface WidgetFontSizePickerProps {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly disabled?: boolean;
    onChange(value: string): void;
}

export const WidgetFontSizePicker: FC<WidgetFontSizePickerProps> = props => {
    return (
        <WidgetLengthPickerLine label={props.label ?? "Font size"} value={props.value} defaultValue={props.defaultValue} disabled={props.disabled} onChange={props.onChange} />
    );
};